import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { deleteVehicle } from "../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";

import { spinnerService } from "@chevtek/react-spinners";
// core components
import { Link } from "react-router-dom";
import tableStyle from "../assets/jss/material-dashboard-react/components/tableStyle.jsx";

import { toast } from "react-toastify";

class CustomTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      tableHead,
      tableData,
      tableHeaderColor,
    } = this.props;
    return (
      <div className={classes.tableResponsive}>
        <Table className={classes.table}>
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow>
              {tableHead !== undefined
                ? tableHead.map((heading, key) => {
                    return (
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeadCell
                        }
                        key={key}
                      >
                        {heading}
                      </TableCell>
                    );
                  }, this)
                : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.length !== 0
              ? tableData.map((item, key) => {
                  let inspectingSince=item.inspectingSince===null?new Date().getFullYear():new Date(item.inspectingSince).getFullYear();
                  let years=inspectingSince-new Date().getFullYear()<=0?`< 1 Year`:inspectingSince-new Date().getFullYear()===1?'1 Year':`${inspectingSince-new Date().getFullYear()} Years`
                  return (
                    <TableRow key={key}>
                      <TableCell className={classes.tableCell}>
                        {item.name}
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        {item.email}
                      </TableCell>

                      <TableCell className={classes.tableCell}>
                        {years}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Link
                          to={{
                            pathname: `/inspector/view/${item.id}`
                          }}
                        >
                          Details
                        </Link>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Link
                          to={{
                            pathname: `/inspector/edit/${item.id}`
                          }}
                        >
                          Edit
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                }, this)
              : null}
          </TableBody>
        </Table>
      </div>
    );
  }
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};

export default withStyles(tableStyle)(CustomTable);



// WEBPACK FOOTER //
// ./src/admin/InspectorTable.jsx